import React from 'react';
import Breadcrumb from '../components/common/Breadcrumb';

const ReturnsPage = () => {
  return (
    <div className="bg-white min-h-screen py-8">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="border-b pb-4 mb-8">
          <Breadcrumb items={[{ label: 'Home', path: '/' }, { label: 'Returns & Exchange', path: '/returns' }]} />
        </div>
        <h1 className="text-3xl font-light text-center text-gray-900 mb-8 tracking-wide">Returns & Exchange Policy</h1>
        <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
          <p>We want you to be completely satisfied with your purchase.</p>
          <p><strong>Return Period:</strong> You may return unworn items within 7 days of delivery for a full refund or exchange.</p>
          <p><strong>Condition:</strong> Items must be in original condition with all tags attached and packaging intact.</p>
          <p><strong>Process:</strong> To initiate a return, contact our support team with your order number. Return shipping costs are covered by the customer.</p>
          <p><strong>Refunds:</strong> Refunds will be processed within 5-7 business days after we receive the returned item.</p>
        </div>
      </div>
    </div>
  );
};

export default ReturnsPage;